// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pretty.p-curve.nueva .state label:after,.pretty.p-curve.nueva .state label:before{content:\"\";left:40px;margin-top:10px;position:absolute}.pretty.p-curve.nueva input:checked~.state label:after{content:\"\";left:40px;margin-top:14px;position:absolute}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
